import Input from "@hudson/ui/components/FormFields/Input";
import Field from "@hudson/ui/components/FormFields/Field";

function FaxNumber({
  errorFormatMessage,
  errorMessage,
  fieldName,
  label,
  onBlur,
}: {
  errorFormatMessage: string;
  errorMessage?: string;
  fieldName: string;
  label: string;
  onBlur?: () => void;
}): JSX.Element | null {
  return (
    <Field
      errorMessage={errorMessage}
      fieldControl={(value, onChange, inError, handleBlur) => (
        <Input
          autoComplete="fax"
          className="w-64"
          inError={inError}
          onBlur={handleBlur}
          onChange={onChange}
          required={Boolean(errorMessage)}
          type="tel"
          value={value ? String(value) : ""}
        />
      )}
      fieldName={fieldName}
      fieldValidations={{
        required: errorMessage,
        validate: (value) => !value || value.replace(/\D/g, "").length >= 8 || errorFormatMessage,
      }}
      label={label}
      onBlur={onBlur}
    />
  );
}

export default FaxNumber;